import { render, staticRenderFns } from "./PartnerCustomer.vue?vue&type=template&id=52e98242&scoped=true&"
import script from "./PartnerCustomer.vue?vue&type=script&lang=js&"
export * from "./PartnerCustomer.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCustomer.vue?vue&type=style&index=0&id=52e98242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e98242",
  null
  
)

export default component.exports